import React from 'react';

const StepDescription = ({children}) => {
  return (
      <p className="text-gray-600">
        {children}
      </p>
  );
};

export default StepDescription;